"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useErrorPages_1 = __importDefault(require("../../../Hooks/useErrorPages"));
const ErrorPage_1 = __importDefault(require("./ErrorPage"));
const NotFoundPage = () => {
    const errorPages = (0, useErrorPages_1.default)();
    const pageData = errorPages === null || errorPages === void 0 ? void 0 : errorPages.notFoundPage;
    return (react_1.default.createElement(ErrorPage_1.default, { pageData: pageData, title: pageData === null || pageData === void 0 ? void 0 : pageData.title, body: pageData === null || pageData === void 0 ? void 0 : pageData.body, links: pageData === null || pageData === void 0 ? void 0 : pageData.links, isNotFoundPage: true }));
};
exports.default = NotFoundPage;
